import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ListContractDigitizationMohaComponent} from './list-contract/list-contract.component';
import {AddContractDigitizationMohaComponent} from './add-contract/add-contract.component';


const routes: Routes = [
  {
    path: '',
    component: ListContractDigitizationMohaComponent
  },
  {
    path: 'create',
    component: AddContractDigitizationMohaComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_create_moha'],
    }
  },
  {
    path: ':contractID/update',
    component: AddContractDigitizationMohaComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_update_moha'],
    }
  },
  {
    path: ':contractID/view',
    component: AddContractDigitizationMohaComponent,
    data: {
      breadcrumb: ['breadcrumbs.document_digitization_view_moha'],
    }
  },
  
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractDigitizationMohaRoutingModule { }
